import React, { useState } from "react";
import { Row, Col, Card, ListGroup } from "react-bootstrap";
import "./InfoOffer.css";
import Masonry from "react-masonry-css";
import { Dropdown } from "primereact/dropdown";
import { SimpleButton, BookButton } from "../../styles";
import { difficultyImages } from "../../../data/difficultyImages";

function InfoOffer({ offers, onReturn, onBook, isBookingStage = false }) {
  const [selectedPeople, setSelectedPeople] = useState(1); // State for selected number of people

  const formatItineraryText = (text) => {
    // Add a CSS class 'tag-heading' to "Tag X"
    return text.replace(/(Tag \d+)/g, '<span class="tag-heading">$1</span>');
  };

  const maxGuests = parseInt(offers.maxGuests, 10) || 1;
  const peopleOptions = Array.from({ length: maxGuests }, (_, i) => ({
    label: `${i + 1} Person${i > 0 ? "en" : ""}`,
    value: i + 1,
  })); // Dropdown options for selecting number of people

  const pricePerPerson = offers.prices[selectedPeople] || "Preis auf Anfrage";

  // Masonry settings for breakpoints
  const breakpointColumnsObj = {
    default: 3, // 3 columns default
    1100: 2, // 2 columns for screens less than 1100px wide
    700: 1, // 1 column for screens less than 700px wide
  };

  function Expectations() {
    // if we do not have itemized expectations use the short description:
    if (!offers.expectations)
      return (
        <div className="itinerary-column">
          <p
            dangerouslySetInnerHTML={{
              __html: formatItineraryText(offers.text_overview),
            }}
          />
        </div>
      );
    return (
      <Row className="my-5">
        {offers.expectations && (
          <>
            <Col md={6}>
              <ListGroup variant="flush">
                {offers.expectations
                  .slice(0, Math.ceil(offers.expectations.length / 2))
                  .map((item, index) => (
                    <ListGroup.Item key={index}>{item}</ListGroup.Item>
                  ))}
              </ListGroup>
            </Col>
            <Col md={6}>
              <ListGroup variant="flush">
                {offers.expectations
                  .slice(Math.ceil(offers.expectations.length / 2))
                  .map((item, index) => (
                    <ListGroup.Item key={index}>{item}</ListGroup.Item>
                  ))}
              </ListGroup>
            </Col>
          </>
        )}
      </Row>
    );
  }

  return (
    <div className="info-offer">
      {/* Upper Part */}
      <section className="infoOffer-section">
        <Row className="my-5">
          <Col md={6} className="custom-margin">
            <h1>{offers.title || "Title of the Offer"}</h1>
            <h3>{offers.subtitle || "Subtitle goes here"}</h3>

            {/* Five Rows with Two Columns Each */}
            <Row className="row-info">
              <Col md={6} className="custom-info">
                <h4>Termin:</h4>
              </Col>
              <Col md={6} className="custom-info-right">
                <p>{offers.date}</p>
              </Col>
            </Row>

            <Row className="row-info">
              <Col md={6} className="custom-info">
                <h4>Dauer:</h4>
              </Col>
              <Col md={6} className="custom-info-right">
                <p>{offers.duration}</p>
              </Col>
            </Row>

            <Row className="row-info">
              <Col md={6} className="custom-info">
                <h4>Ort:</h4>
              </Col>
              <Col md={6} className="custom-info-right">
                <p>{offers.place}</p>
              </Col>
            </Row>

            <Row className="row-info">
              <Col md={6} className="custom-info">
                <h4>Gruppengröße:</h4>
              </Col>
              <Col md={6} className="custom-info-right">
                <p>max. {offers.maxGuests} Personen</p>
              </Col>
            </Row>

            <Row className="row-info">
              <Col md={6} className="custom-info">
                <h4>Anforderung Gesamt:</h4>
              </Col>
              <Col md={6} className="custom-info-right">
                <img
                  src={difficultyImages[offers.overalleLevel]} // Use offers.overalleLevel to get the correct image
                  alt={`Level ${offers.overalleLevel}`}
                  className="difficulty-image" // Add a class for styling, if needed
                />
              </Col>
            </Row>

            <Row className="row-info">
              <Col md={6} className="custom-info">
                <h4>Anforderung Technik:</h4>
              </Col>
              <Col md={6} className="custom-info-right">
                <img
                  src={difficultyImages[offers.levelTech]} // Use offers.levelTech for the technical level image
                  alt={`Level Tech ${offers.levelTech}`}
                  className="difficulty-image"
                />
                <p>{offers.levelTechText}</p>
              </Col>
            </Row>

            <Row className="row-info">
              <Col md={6} className="custom-info">
                <h4>Anforderung Kondition:</h4>
              </Col>
              <Col md={6} className="custom-info-right">
                <img
                  src={difficultyImages[offers.levelFitness]} // Use offers.levelFitness for the fitness level image
                  alt={`Level Fitness ${offers.levelFitness}`}
                  className="difficulty-image"
                />
                <p>{offers.levelFitnessText}</p>
              </Col>
            </Row>
          </Col>

          <Col md={6} className="text-center">
            <img
              src={offers.imgHead}
              alt="Offer"
              fluid="true"
              className="custom-image"
            />
            <Card className="mt-3">
              <Card.Body className="price">
                <h4>{`Preis ${offers.price || "999"}`}</h4>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </section>

      {/* Custom Divider */}
      <section className="infoOffer-section">
        <Row className="my-5">
          <Col>
            <div className="custom-divider">
              <span className="divider-text">
                <b>Was dich erwartet</b>
              </span>
            </div>
          </Col>
        </Row>
      </section>

      {/* What to Expect */}
      <section className="infoOffer-section">
        <Expectations />
      </section>

      {/* Galerie */}
      <section className="infoOffer-section">
        <Row className="my-5">
          <Col>
            <div className="custom-divider">
              <span className="divider-text">
                <b>Eindrücke</b>
              </span>
            </div>
          </Col>
        </Row>
      </section>

      <section className="infoOffer-galerie">
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="masonry-grid"
          columnClassName="masonry-grid_column"
        >
          <div className="masonry-item">
            <img
              src={offers.imgOne}
              alt="Gallery 1"
              className="gallery-image"
            />
            <p className="gallery-description"> {offers.descrImgOne}</p>
          </div>
          <div className="masonry-item">
            <img
              src={offers.imgTwo}
              alt="Gallery 2"
              className="gallery-image"
            />
            <p className="gallery-description">{offers.descrImgTwo}</p>
          </div>
          <div className="masonry-item">
            <img
              src={offers.imgThree}
              alt="Gallery 3"
              className="gallery-image"
            />
            <p className="gallery-description">{offers.descrImgThree}</p>
          </div>
        </Masonry>
      </section>

      {/* Custom Divider */}
      <section className="infoOffer-section">
        <Row className="my-5">
          <Col>
            <div className="custom-divider">
              <span className="divider-text">
                <b>Tagesablauf</b>
              </span>
            </div>
          </Col>
        </Row>
      </section>

      {/* Itinerary */}
      <section className="infoOffer-section">
        <div className="itinerary-column">
          {/*<h5>Tag 1</h5>*/}

          {offers.text_itinerary.split(/(?=Tag \d+:)/g).map((entry, index) => {
            const match = entry.match(/Tag (\d+):\s*(.*)/s);
            if (!match) return null;

            const day = match[1];
            const content = match[2];

            return (
              <div key={index} className="itinerary-day">
                <h5 className="itinerary-day-heading">Tag {day}</h5>
                <p className="itinerary-day-content">{content}</p>
              </div>
            );
          })}
        </div>
      </section>

      {!isBookingStage && (
        <>
          {/* Custom Divider */}
          <section className="infoOffer-section">
            <Row className="my-5">
              <Col>
                <div className="custom-divider">
                  <span className="divider-text">
                    <b>Kosten</b>
                  </span>
                </div>
              </Col>
            </Row>
          </section>

          <section className="infoOffer-section">
            <Row className="my-5 justify-content-center">
              {/* Dropdown */}
              <Col md="auto" className="text-center">
                <h5>Anzahl der Personen</h5>
                <Dropdown
                  value={selectedPeople}
                  onChange={(e) => setSelectedPeople(e.value)}
                  options={peopleOptions}
                  className="dropdown-custom"
                />
              </Col>

              {/* Price per Person */}
              <Col md="auto" className="text-center mx-5">
                <h5>Preis</h5>
                <p className="price-per-person">{`€ ${pricePerPerson}`}</p>
              </Col>
            </Row>

            {/* Book Now Button */}
            <div className="text-center mt-4">
              <BookButton onClick={() => onBook(offers.id)} />
            </div>
          </section>
        </>
      )}

      {/* Dynamic Cost Breakdown */}
      <section className="infoOffer-section">
        <Row className="my-5">
          {offers.inclServices && Array.isArray(offers.inclServices) && (
            <Col md={6}>
              <h5 className="fw-bold">Leistungen inklusive</h5>
              <ListGroup variant="flush">
                {offers.inclServices.map((service, index) => (
                  <ListGroup.Item key={index}>{service}</ListGroup.Item>
                ))}
              </ListGroup>
            </Col>
          )}

          {offers.exclServices && (
            <Col md={6}>
              <h5 className="fw-bold">Leistungen exklusive</h5>
              <ListGroup variant="flush">
                {/* If exclServices is a string, split it into an array */}
                {Array.isArray(offers.exclServices)
                  ? offers.exclServices.map((service, index) => (
                      <ListGroup.Item key={index}>{service}</ListGroup.Item>
                    ))
                  : offers.exclServices
                      .split(",")
                      .map((service, index) => (
                        <ListGroup.Item key={index}>
                          {service.trim()}
                        </ListGroup.Item>
                      ))}
              </ListGroup>
            </Col>
          )}
        </Row>
      </section>

      {/* Conditionally Render Return Button */}
      {!isBookingStage && (
        <div className="text-center mt-4">
          <SimpleButton
            label="Zurück zur Übersicht"
            onClick={onReturn}
            variant="secondary"
          />
        </div>
      )}
    </div>
  );
}

export default InfoOffer;
